"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasFolderRequestInitialized = exports.hasFolderRequestSucceeded = exports.getFolderRequestInfo = exports.getFolderTree = exports.getSelectedFolderAncestors = exports.getParentFolderForFile = exports.getFileFromProps = exports.getSelectedFolder = exports.getFoldersCount = exports.getFoldersById = exports.getFolders = exports.findFolderByPath = void 0;

var _reselect = require("reselect");

var _FoldersAndFiles = require("../utils/FoldersAndFiles");

var _Constants = require("../Constants");

var findFolderByPath = function findFolderByPath(folders, path) {
  if (!path) {
    return null;
  }

  return folders.find(function (folder) {
    return folder.get('full_path') === path;
  });
};

exports.findFolderByPath = findFolderByPath;

var getFolders = function getFolders(state) {
  return state.folders.get('objects').toList();
};

exports.getFolders = getFolders;

var getFoldersById = function getFoldersById(state) {
  return state.folders.get('objects');
};

exports.getFoldersById = getFoldersById;

var getFoldersCount = function getFoldersCount(state) {
  return state.folders.get('total');
};

exports.getFoldersCount = getFoldersCount;

var getSelectedFolder = function getSelectedFolder(state, props) {
  return props.selectedFolder;
};

exports.getSelectedFolder = getSelectedFolder;

var getFileFromProps = function getFileFromProps(state, props) {
  return props.file;
};

exports.getFileFromProps = getFileFromProps;
var getParentFolderForFile = (0, _reselect.createSelector)([getFileFromProps], _FoldersAndFiles.getParentFolder);
exports.getParentFolderForFile = getParentFolderForFile;
var getSelectedFolderAncestors = (0, _reselect.createSelector)([getSelectedFolder, getFoldersById], _FoldersAndFiles.getAncestors);
exports.getSelectedFolderAncestors = getSelectedFolderAncestors;
var getFolderTree = (0, _reselect.createSelector)([getFoldersById], _FoldersAndFiles.makeFolderTree);
exports.getFolderTree = getFolderTree;

var getFolderRequestInfo = function getFolderRequestInfo(state, requestType, requestLookupKey) {
  return state.folders.getIn(['requests', requestType, requestLookupKey]);
};

exports.getFolderRequestInfo = getFolderRequestInfo;

var hasFolderRequestSucceeded = function hasFolderRequestSucceeded(state, requestType, requestLookupKey) {
  var requestInfo = getFolderRequestInfo(state, requestType, requestLookupKey);
  return requestInfo && requestInfo.get('status') === _Constants.RequestStatus.SUCCEEDED;
};

exports.hasFolderRequestSucceeded = hasFolderRequestSucceeded;

var hasFolderRequestInitialized = function hasFolderRequestInitialized(state, requestType, requestLookupKey) {
  var requestInfo = getFolderRequestInfo(state, requestType, requestLookupKey);
  return requestInfo && [_Constants.RequestStatus.SUCCEEDED, _Constants.RequestStatus.PENDING].includes(requestInfo.get('status'));
};

exports.hasFolderRequestInitialized = hasFolderRequestInitialized;